import _ from 'lodash';
import React, { Component } from 'react';
import * as CLIntF from '../../../interfaces/classroomLessons';
import StudentSingleAnswer from '../../classroomLessons/play/singleAnswer';
import CuesField from './slideComponents/cuesField';
import PromptField from './slideComponents/promptField';
import SlidePreview from './slideComponents/slidePreview';
import TextField from './slideComponents/textField';
import TitleField from './slideComponents/titleField';
import { parseCues } from '../../../../Shared/index';

interface SingleAnswerProps {
  question: CLIntF.QuestionData,
  updateQuestion: Function,
  clearSlide: Function,
  resetSlide: Function,
  questionIndex: number,
  incompletePrompt: Boolean
}

class CustomizeSingleAnswer extends Component<SingleAnswerProps, {}>{
  constructor(props){
    super(props);

    this.handleTitleChange = this.handleTitleChange.bind(this)
    this.handlePromptChange = this.handlePromptChange.bind(this)
    this.handleInstructionsChange = this.handleInstructionsChange.bind(this)
    this.handleCuesChange = this.handleCuesChange.bind(this)
    this.handlePrefilledTextChange = this.handlePrefilledTextChange.bind(this)
    this.updateQuestion = this.updateQuestion.bind(this)
  }

  updateQuestion(newVals, questionIndex) {
    this.props.updateQuestion(newVals, questionIndex)
  }

  handleTitleChange(e) {
    const newVals = _.merge({}, this.props.question)
    _.set(newVals, 'teach.title', e.target.value)
    this.updateQuestion(newVals, this.props.questionIndex)
  }

  handlePromptChange(e) {
    const newVals = _.merge({}, this.props.question)
    _.set(newVals, 'play.prompt', e)
    this.updateQuestion(newVals, this.props.questionIndex)
  }

  handleInstructionsChange(e) {
    const newVals = _.merge({}, this.props.question)
    _.set(newVals, 'play.instructions', e.target.value)
    this.updateQuestion(newVals, this.props.questionIndex)
  }

  handleCuesChange(e) {
    const newVals = _.merge({}, this.props.question)
    const formattedCues = parseCues(e.target.value);
    _.set(newVals, 'play.cues', formattedCues)
    this.updateQuestion(newVals, this.props.questionIndex)
  }

  handlePrefilledTextChange(e) {
    const newVals = _.merge({}, this.props.question)
    _.set(newVals, 'play.prefilledText', e.target.value)
    this.updateQuestion(newVals, this.props.questionIndex)
  }

  render() {
    const { clearSlide, questionIndex, resetSlide, question, incompletePrompt, } = this.props
    const instructionsInputId = `instructions-${questionIndex}`
    const prefilledTextInputId = `prefilled-text-${questionIndex}`

    return (
      <div className="slide">
        <div className="form">
          <TitleField
            clearSlide={clearSlide}
            handleTitleChange={this.handleTitleChange}
            questionIndex={questionIndex}
            resetSlide={resetSlide}
            title={question.teach.title}
          />
          <PromptField
            handleTextChange={(e) => this.handlePromptChange(e)}
            incompletePrompt={incompletePrompt}
            questionIndex={questionIndex}
            reset={question.reset}
            showBlockquote={false}
            text={question.play.prompt}
          />
          <TextField
            handleChange={this.handleInstructionsChange}
            id={instructionsInputId}
            label="Instructions"
            optional
            value={question.play.instructions}
          />
          <CuesField
            cues={Object.values(question.play.cues || {})}
            handleCuesChange={(e) => this.handleCuesChange(e)}
            questionIndex={questionIndex}
          />
          <TextField
            handleChange={this.handlePrefilledTextChange}
            id={prefilledTextInputId}
            label="Prefilled Text"
            optional
            value={question.play.prefilledText}
          />
        </div>
        <SlidePreview slideNumber={questionIndex}>
          <StudentSingleAnswer data={question} />
        </SlidePreview>
      </div>
    )
  }

}

export default CustomizeSingleAnswer
